import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { Toast } from 'primeng/toast';
import { RestaurantFormComponent } from '../../_components/restaurant-form/restaurant-form.component';
import {Constants} from '../../_utility';
import {Router} from '@angular/router';
import {MessageService} from 'primeng/api';
import {AuthService} from '../../_services';
import {BreadcrumbsService} from '../../_components/breadcrumbs/breadcrumbs.service';

@Component({
  selector: 'app-new-restaurant',
  templateUrl: './new-restaurant.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [RestaurantFormComponent, TranslateModule, DynamicDialogModule],
  styles: [
    `
      .card-header {
        padding: 1rem;
        border-bottom: 1px solid #dee2e6;
        margin-bottom: 1.5rem;
      }
      .card-header h1 {
        margin: 0;
        font-size: 1.5rem;
      }
      .d-flex {
        display: flex !important;
      }
      .justify-content-between {
        justify-content: space-between !important;
      }
      .align-items-center {
        align-items: center !important;
      }
      .mb-0 {
        margin-bottom: 0 !important;
      }
      :host ::ng-deep .custom-toast {
        top: 20px !important;
      }
      :host ::ng-deep .p-toast-message {
        margin: 0 auto;
      }
    `,
  ],
})
export class NewRestaurantComponent implements OnInit {
  public ships: any[] = [];
  public dataShips: any[] = [];
  protected readonly Constants = Constants;

  constructor(
    private router: Router,
    private auth: AuthService,
    private messageService: MessageService,
    private breadcrumb: BreadcrumbsService,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    setTimeout(() => {
      this.breadcrumb.setCrumbs(Constants.Routing.NUOVO_RISTORANTE.path);
    }, 200);

    const currentUser = this.auth.getCurrentUser();
    if (currentUser) {
      // Get user's ships from local storage
      const userDataStr = localStorage.getItem('currentUser');
      if (userDataStr) {
        const userData = JSON.parse(userDataStr);
        if (userData.ships && userData.ships.length > 0) {
          // Transform ships data to match the format needed by the dropdown
          this.ships = userData.ships.map((ship: any) => ({
            name: ship,
            code: ship,
          }));
        }
      }
    }
  }

  Back() {
    this.goTo('restaurant_management');
  }

  goTo(path: string) {
    switch (path) {
      case 'home': {
        this.router.navigate(Constants.Routing.HOME.routerLink);
        break;
      }
      case 'restaurant_management': {
        this.router.navigate(Constants.Routing.HOME_RISTORANTI.routerLink);
        break;
      }
    }
  }

  showResult(event: boolean) {
    if (event) {
      this.messageService.add({
        severity: 'success',
        summary: this.translate.instant('messages.success_title'),
        detail: this.translate.instant('messages.restaurant_created'),
        life: Constants.Notifications.LIFE,
        key: Constants.Notifications.SUCCESS_KEY,
      });
    }
  }
}
